
import { mixins, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { TokenCartItem } from '@/api/shopify/types';
import LoadingScreen from '@/components/LoadingScreen.vue';
import MTokenCartItem from '@/components/shopify/MTokenCartItem.vue';
import CheckoutWidgetMixin from '@/mixins/checkoutWidget';

@Options({
  components: {
    MTokenCartItem,
    LoadingScreen
  }
})
export default class MTokenCart extends mixins(CheckoutWidgetMixin) {
  popupIsOpen = false;
  htmlOverflowInitial: string | undefined;
  bodyOverflowInitial: string | undefined;
  eligibleRewards: any[] = [];
  productHasRewards = false;
  show = false;
  pendingDraftOrder = '';
  shopifyCartItems: TokenCartItem[] = [];

  @Watch('state.storedShopifyCart')
  async cartItemsWatcher(_value: any, _oldValue: any) {
    // const savedCart = this.state.storedShopifyCart;
    // Check if any token-gated items are in cart
    const allItems = this.state.storedShopifyCart.items || [];

    this.shopifyCartItems = allItems;
  }
}
